var _a;
export const SANBASE_ORIGIN = (_a = process.env.SANBASE_ORIGIN) !== null && _a !== void 0 ? _a : 'https://app.santiment.net';
//# sourceMappingURL=links.js.map